var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stockDetail" }, [
    _c("div", { staticClass: "topMain" }, [
      _c("p", { staticClass: "pg" }, [
        _vm._v(_vm._s(_vm.stockDetailObj.resourceNameCn)),
      ]),
      _c("p", { staticClass: "ml" }, [
        _c("span", { staticClass: "sp" }, [
          _vm._v(_vm._s(_vm.stockDetailObj.productNameCn)),
        ]),
      ]),
      _c("p", { staticClass: "top" }, [
        _vm._v(" " + _vm._s(_vm.stockDetailObj.productStockDesc) + " "),
      ]),
      _c(
        "p",
        {
          staticStyle: {
            color: "rgb(176, 3, 3)",
            "border-bottom": "1px solid #f2f2f2",
            "padding-bottom": "10px",
          },
        },
        [
          _vm.stockDetailObj.recommendation &&
          _vm.stockDetailObj.recommendation != ""
            ? _c("span", [
                _vm._v(
                  "推荐理由：" + _vm._s(_vm.stockDetailObj.recommendation)
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            { staticStyle: { color: "#155969", "font-size": "12px" } },
            [
              _vm._v(
                _vm._s(
                  _vm.stockDetailObj.cancelType == 1
                    ? "不可取消"
                    : _vm.stockDetailObj.cancelType == 5
                    ? "随时退"
                    : _vm.stockDetailObj.cancelType == 6
                    ? "过期退"
                    : "有条件退"
                )
              ),
            ]
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "inst" }, [
      _c("p", { staticClass: "bg" }, [_vm._v("预定说明：")]),
      _c("p", [
        _vm._v(
          _vm._s(_vm.stockDetailObj.isSplit === 0 ? "可" : "不可") + "拆分购买"
        ),
      ]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("价格有效期：")]),
        _vm._v(
          _vm._s(
            _vm.productType == 1
              ? "长期有效"
              : _vm.dateFormatYMDHM(_vm.stockDetailObj.saleOptionTime, "-")
          )
        ),
      ]),
      _c("p", { staticClass: "bl" }, [
        _c("label", { staticClass: "bl" }, [_vm._v("有效期解释：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.optionTimeExplain)),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "inst" },
      [
        _c("p", { staticClass: "bg" }, [_vm._v("费用说明：")]),
        _c("p", [
          _vm._v(
            _vm._s(_vm.stockDetailObj.isVat === 0 ? "含" : "不含") +
              "VAT  " +
              _vm._s(
                _vm.stockDetailObj.isCityTax == 0
                  ? "含"
                  : _vm.stockDetailObj.isCityTax == 1
                  ? "不含"
                  : "没有"
              ) +
              "城市税"
          ),
        ]),
        _c("p", [
          _c("label", { staticClass: "bl" }, [_vm._v("费用说明描述：")]),
          _vm._v(_vm._s(_vm.stockDetailObj.costExplain)),
        ]),
        _c("p", { staticClass: "bl" }, [_vm._v("可免费提供的设施及服务为：")]),
        _vm._l(_vm.stockDetailObj.contains, function (item, index) {
          return _c("div", { key: index + "sheshi" }, [
            item.type == 1 || item.type == 2
              ? _c("p", [
                  _vm._v(
                    _vm._s(item.name) +
                      _vm._s(item.number) +
                      "份" +
                      _vm._s(item.containDescribe)
                  ),
                ])
              : _vm._e(),
          ])
        }),
        _c("p", { staticClass: "bl" }, [_vm._v("可有偿提供的设施及服务为：")]),
        _vm._l(_vm.stockDetailObj.contains, function (item, index) {
          return _c("div", { key: index + "sheshi1" }, [
            item.type == 3 || item.type == 4
              ? _c("p", [
                  _vm._v(
                    _vm._s(item.name) +
                      _vm._s(item.number) +
                      "份" +
                      _vm._s(item.containDescribe)
                  ),
                ])
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
    _c("div", { staticClass: "inst" }, [
      _c("p", { staticClass: "bg" }, [_vm._v("使用说明：")]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("预定号：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.useNumber)),
      ]),
      _c("p", [_vm._v(_vm._s(_vm.stockDetailObj.useMethod))]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("使用说明描述：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.useExplain)),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "inst" },
      [
        _c("p", { staticClass: "bg" }, [_vm._v("退改说明：")]),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.stockDetailObj.cancelType == 1
                ? "不可取消"
                : _vm.stockDetailObj.cancelType == 5
                ? "随时退"
                : _vm.stockDetailObj.cancelType == 6
                ? "过期退"
                : "有条件退"
            )
          ),
        ]),
        _vm.stockDetailObj.cancelTime && _vm.stockDetailObj.cancelTime != ""
          ? _c("p", [
              _vm._v(
                "产品使用当天" +
                  _vm._s(_vm.stockDetailObj.cancelTime) +
                  "前可免费取消 "
              ),
            ])
          : _vm._e(),
        _vm._l(_vm.stockDetailObj.cancelPolicyList, function (item, index) {
          return _c("p", { key: index }, [
            item.cancelData == ""
              ? _c("span", [
                  _vm._v(
                    "使用日期前" +
                      _vm._s(item.day) +
                      "天" +
                      _vm._s(item.cancelTime) +
                      "前可免费取消" +
                      _vm._s(item.cancelProportion) +
                      "%"
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.dateFormatYMD(item.cancelData, "-")) +
                      "日" +
                      _vm._s(item.cancelTime) +
                      "前可免费取消" +
                      _vm._s(item.cancelProportion) +
                      "%"
                  ),
                ]),
          ])
        }),
        _c("p", [
          _c("label", { staticClass: "bl" }, [_vm._v("退改说明：")]),
          _vm._v(_vm._s(_vm.stockDetailObj.cancelExplain)),
        ]),
      ],
      2
    ),
    _c("div", { staticClass: "inst" }, [
      _c("p", { staticClass: "bg" }, [_vm._v("其他说明：")]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("发票须知：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.invoiceExplain)),
      ]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("其他须知：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.otherExplain)),
      ]),
      _c("p", [
        _c("label", { staticClass: "bl" }, [_vm._v("安全须知：")]),
        _vm._v(_vm._s(_vm.stockDetailObj.securityExplain)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }